export default __webpack_public_path__ + "static/media/XshareLogo.ab300fdc.svg";